module.exports = __webpack_public_path__ + "static/media/UIUX.9fb8cee3.svg";